import * as React from 'react';
import type { SVGProps } from 'react';

export function RaiseHandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M19.5 9.5c-.83 0-1.5.67-1.5 1.5v2.5h-1V5.5C17 4.67 16.33 4 15.5 4S14 4.67 14 5.5V13h-1V3.5C13 2.67 12.33 2 11.5 2S10 2.67 10 3.5V13H9V5.5C9 4.67 8.33 4 7.5 4S6 4.67 6 5.5v10.25l-1.8-1.35c-.66-.5-1.58-.44-2.18.15-.64.63-.64 1.66.01 2.28l6.26 6.1C9.05 23.7 10.12 24 11.22 24h4.06c2.62 0 4.78-1.97 5.08-4.56l.64-5.45c.06-.54.1-1.08.1-1.49v-1.5c0-.83-.67-1.5-1.6-1.5z" />
    </svg>
  );
}
